<div class="ep-container">
    <img src="assets/img/error/prop2.png" class="ep-image" />
    <div class="ep-text">
        We're sorry, your deal could not be found or is no longer available.
    </div>
    <button mdMainButton="light" (click)="goHome()">Go to homepage</button>
</div>
